module.exports = __webpack_public_path__ + "static/offers-mobile-2d1da1a68656e5b3ce3446ea3e87da53.png";